import { Deserializer } from 'jsonapi-serializer';
import { genericError } from "../models/GenericError";
import { ListQuery } from "../models/ListQuery";
import { Name } from "../models/Name";
import { PaginationModel } from "../models/Pagination";
import { APIConnector } from "./api/APIConnector";
import { createPagination } from "./utilities/paginationBuilder";
import { getConstraintViolation, processServerError } from "./utilities/ServiceError";
import { createPartialURL, getFilterClause } from "./utilities/urlBuilder";
import { MODE_TYPE_ARMED } from '../constants/mode-type';

const apiConnector = new APIConnector();

export const getModeTypeNames = async (listParameters?: ListQuery): Promise<{ rows: Name[], pagination: PaginationModel }> => {
    try {
        const filters: string = getFilterClause(listParameters?.filters, listParameters?.searchTerm);
        const filterToExcludeArmedMode = filters ? `${filters};id=out=${MODE_TYPE_ARMED}` : `&filter=id=out=${MODE_TYPE_ARMED}`; // Armed mode is not supported
        const paginationString = createPartialURL(listParameters?.goToPage, listParameters?.pageSize, listParameters?.sortBy, filterToExcludeArmedMode);
        const url = `modeType?fields[modeType]=trnName${paginationString}`;
        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const newPagination = createPagination(json.meta);

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }

            new Deserializer().deserialize(json, (err: any, items: any[]) => {
                if (err) {
                    return reject({status: response.status, message: genericError });
                }

                const modeTypes: Name[] = items.map((modeType): Name => {
                    return {
                        value: modeType['id'],
                        label: modeType['trn-name']
                    };
                });

                return resolve({ rows: modeTypes, pagination: newPagination });
            })
        })
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}
